import script from "./CompMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CompMultiSelect.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__